import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Plausible from 'plausible-tracker';

const plausible = Plausible({
	domain: 'erledix.de',
});

export default function PlausibleAnalytics() {
	const location = useLocation();

	useEffect(() => {
		plausible.trackPageview({ url: window.location.href.split('#')[0] });
	}, [location]);

	return null;
}
